module.exports = __webpack_public_path__ + "static/media/Linearicons-Free.03e91f12.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/architect/components/icons/linearicons/Linearicons-Free.woff2
// module id = 323
// module chunks = 0